import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

export const isGranted = ({ admin, type }, adminRequired = false, types = []) => {
  if (!type) {
    return false
  }

  if (admin) {
    return true
  }

  if (adminRequired && !admin) {
    return false
  }

  if (types.length === 0) {
    return true
  }

  if (!types.includes(type)) {
    return false
  }

  return true
}

export default (WrappedComponent, adminRequired = false, types = [], fieldAccess = null) => {
  const WithSecurity = (props) => {
    if (!props.isGranted(adminRequired, types)) {
      return <Redirect to="/login" />
    }

    if (!props.admin && props.accountStatus !== 'accepted' && props.match.path !== '/vouchers') {
      return <Redirect to="/vouchers" />
    }

    if (!props.tos && props.match.path !== '/tos/verify') {
      return <Redirect to="/tos/verify" />
    }

    if (fieldAccess) {
      const hasAccess = Boolean(props[fieldAccess])

      if (!hasAccess && props.match.path !== '/deliveries/ongoing') {
        return <Redirect to="/deliveries/ongoing" />
      }
    }

    return <WrappedComponent {...props} />
  }

  WithSecurity.propTypes = {
    isGranted: PropTypes.func.isRequired,
    accountStatus: PropTypes.string,
    tos: PropTypes.bool.isRequired,
    admin: PropTypes.bool,
    match: PropTypes.object,
  }

  const mapStateToProps = (state) => ({
    isGranted: (adminRequired, types) => isGranted(state.security, adminRequired, types),
    accountStatus: state.security.status,
    tos: state.profile.fetch.loading || (state.profile.payload || {}).termsOfUseAccepted,
    admin: state.security.admin,
    accessProfitabilityCalculator:
      state.profile.fetch.loading || (state.profile.payload || {}).accessProfitabilityCalculator || false,
    accessCourierGeolocation:
      state.profile.fetch.loading || (state.profile.payload || {}).accessCourierGeolocation || false,
    accessTimeManagement: state.profile.fetch.loading || (state.profile.payload || {}).accessTimeManagement || false,
    accessOperationsMonitoring:
      state.profile.fetch.loading || (state.profile.payload || {}).accessOperationsMonitoring || false,
    accessDropoffConfiguration:
      state.profile.fetch.loading || (state.profile.payload || {}).accessDropoffConfiguration || false,
    accessCustomLandingPage:
      state.profile.fetch.loading || (state.profile.payload || {}).accessCustomLandingPage || false,
  })

  return connect(mapStateToProps)(WithSecurity)
}
